import { Link } from 'react-router-dom';
import InstanceTarget from '../../types/instance/InstanceTarget';

const INSTANCE_TYPE_NAMES: { [key: string]: string } = {
    'cockroachdb': 'CockroachDB',
    'db2': 'DB2',
    'informix': 'Informix',
    'mysql': 'MySQL',
    'oracle': 'Oracle',
    'postgresql': 'PostgreSQL',
    'saphana': 'SAP HANA',
    'sqlserver': 'SQL Server',
    'sybase': 'SAP (Sybase) ASE',
    'mongodb': 'MongoDB'
};

interface TabDisabledBannerProps {
    instance: InstanceTarget;
    instanceTypes: any[];
    collectFlag: boolean;
    defaultCollectKey: string;
    featureName: string;
}

export default function TabDisabledBanner({ instance, instanceTypes, collectFlag, defaultCollectKey, featureName }: TabDisabledBannerProps) {
    if (collectFlag) {
        return null;
    }

    // Don't show banner until instanceTypes have loaded to prevent flashing
    if (!instanceTypes.length) {
        return null;
    }

    // Check if collection is on by default for this instance type.
    // If so, data should already exist — no need to show the banner.
    const instanceType = instance.type || '';
    const typeDefaults = instanceTypes.find(t => t.type === instanceType);
    const defaultCollect = typeDefaults ? typeDefaults[defaultCollectKey] : false;

    if (defaultCollect) {
        return null;
    }

    const typeName = INSTANCE_TYPE_NAMES[instanceType] || instanceType;
    const docsUrl = `https://docs.dbmarlin.com/docs/Monitored-Technologies/Databases/${instanceType}`;

    return (
        <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">{featureName} collection disabled</h4>
            <p>
                Data collection for {featureName} is currently disabled.
                Please check that the necessary permissions have been granted
                in <Link to={`/admin/instances/edit/${instance.id}`}>Advanced Settings</Link>.
                {typeName && (
                    <> See the <a href={docsUrl} target="_blank" rel="noopener noreferrer">{typeName} documentation</a> for details.</>
                )}
            </p>
        </div>
    );
}
